import React from 'react';

import { AlertType } from '@lux/inline-alert';
import {
    TYPE_ERROR,
    TYPE_INFO,
    TYPE_SUCCESS,
    TYPE_WARNING,
} from '@pegasus/ui-flashmessages/dist/constants';

export type FlashmessageType =
    | typeof TYPE_SUCCESS
    | typeof TYPE_ERROR
    | typeof TYPE_INFO
    | typeof TYPE_WARNING;

export const convertFlashMessageToAlertType = (type: FlashmessageType): AlertType => {
    switch (type) {
        case TYPE_ERROR:
        case TYPE_WARNING: {
            return AlertType.ERROR;
        }
        case TYPE_INFO: {
            return AlertType.INFO;
        }
        case TYPE_SUCCESS: {
            return AlertType.SUCCESS;
        }
        default: {
            return AlertType.INFO;
        }
    }
};

export const ApplicationContext = React.createContext({
    smartbannerVisibility: false,
});
ApplicationContext.displayName = 'ApplicationContext';
